"use strict";

define('rs/form/formdesigner.view',['rs/form/form.view', 'evisions/drag', 'rs/helper', 'd3', 'evisions/redactor.plugins/href.location.redactor.plugin'], function (FormView, EVIDrag, helper, d3) {
  var FormDesignerView = FormView.extend({
    templates: {
      'form.toolbar': 'renderToolbarFragment',
      'form.toolbar.controls': 'renderControlsFragment',
      'form.toolbar.properties': 'renderProperties'
    },
    events: {
      'click .form-toolbar-tab.properties': 'handleToolBarPropertyTab',
      'click .form-toolbar-tab.controls': 'handleToolBarControlsTab',
      'click .checkbox-custom:not(.disabled)': 'handleCustomCheckboxClick',
      'mousedown .form-object': 'handleFormObjectMouseDown',
      'mousedown .form-section': 'handleFormObjectMouseDown',
      'click .form-sidebar-attachment': 'handleAttachmentClick',
      'click .add-section-btn': 'handleAddSectionBtn',
      'keydown .add-section-btn': 'handleAddSectionBtnKeydown',
      'click .add-attachment-btn': 'handleAddAttachmentBtn',
      'keydown .add-attachment-btn': 'handleAddAttachmentBtnKeydown',
      'click .remove-link-btn': 'handleRemoveLinkBtn',
      'click .reveal-link-btn': 'handleRevealLinkBtn',
      'click .go-to-control-btn': 'handleGoToControlBtn',
      'keydown .go-to-control-btn': 'handleGoToControlBtnKeydown',
      'click': 'handleAreaClick',
      'change .property-value': 'handlePropertyValueChange',
      'keyup .property-value': 'handlePropertyValueChange',
      'click .property-button': 'handlePropertyButtonClick',
      'keydown .property-button': 'handlePropertyButtonKeydown',
      'keydown input,textarea,.redactor_box': 'handleInputKeyup',
      'click .section-delete-btn': 'handleSectionDeleteBtn',
      'click .attachment-delete-btn': 'handleAttachmentDeleteBtn',
      'selectstart .redactor_box': 'handleEditInputSelectStart',
      'selectstart input': 'handleEditInputSelectStart',
      'selectstart textarea': 'handleEditInputSelectStart',
      'click .property-item > .remove-btn': 'handlePropertyListRemoveClick'
    },
    handleEditInputSelectStart: function handleEditInputSelectStart(ev) {
      ev.originalEvent = ev.originalEvent || {};
      ev.originalEvent._flag = true;
    },
    setupDrag: function setupDrag() {
      var that = this,
        delegate = this.getDelegate(),
        section = that.$('.form-section-container');
      var controls = this.dragControls = EVIDrag.delegate(this.$el, '.control-type', {
        drag_min_distance: 5
      }).init(function () {
        delegate.requestFormObjectActivate(delegate.getActiveSection(), true);
      }).plugin(EVIDrag.plugins.ghost).set('ghost', function (el) {
        return el.clone().width(el.outerWidth()).css('opacity', .7);
      }).scroll(function (ev) {
        section.scrollTop(section.scrollTop() - ev.originalEvent.wheelDeltaY);
      }).plugin(EVIDrag.plugins.scroller).set('scrollContainer', function () {
        return that.$(".form-section-container");
      });
      controls.delegateDrop('.form-object-drop-area').enter(function (el) {
        var lastInternal = el.hasClass("last-internal"),
          formObject = lastInternal ? el.closest('.form-object') : el.next('.form-object'),
          view = formObject.length > 0 && helper.datum(formObject),
          hoveredObject = view && view.getDelegate();
        if (!view || hoveredObject.canAddChildFormObject()) {
          el.addClass('drop-hover');
        }
      }).exit(function (el) {
        el.removeClass('drop-hover');
      }).drop(function (el) {
        var type = this.getCurrentlyDragged().data('type'),
          view = helper.datum(el.closest('.form-object'));
        if (type && view) {
          view.getDelegate().requestTypeInsertAtEnd(type);
        }
      });
      controls.delegateDrop('.form-object-spacer:not(.last)').enter(function (el) {
        var type = this.getCurrentlyDragged().data('type'),
          formObject = el.closest('.form-object'),
          view = formObject.length > 0 && helper.datum(formObject),
          hoveredObject = view && view.getDelegate();
        if (!hoveredObject || hoveredObject.canAddChildType(type)) {
          if (!view || hoveredObject.canAddChildFormObject()) {
            el.addClass('drop-hover').closest('.form-object').addClass('drop-child-hover');
          }
        }
      }).exit(function (el) {
        el.removeClass('drop-hover').closest('.form-object').removeClass('drop-child-hover');
      }).drop(function (el) {
        var type = this.getCurrentlyDragged().data('type'),
          lastInternal = el.hasClass("last-internal"),
          formObject = lastInternal ? el.closest('.form-object') : el.next('.form-object'),
          view = helper.datum(formObject),
          droppedOnObject = view.getDelegate();
        if (type && view && droppedOnObject.canAddChildFormObject()) {
          if (!lastInternal) {
            var parent = droppedOnObject.getParent();
            if (parent.canAddChildType(type)) {
              parent.requestTypeInsertAtIndex(type, droppedOnObject.getRowIndex());
            }
          } else {
            droppedOnObject.requestTypeInsertAtEnd(type);
          }
        }
      });
      var existing = this.dragExisting = EVIDrag.delegate(this.$el, '.form-object .dragger', {
        drag_min_distance: 5
      }).init(function (ev) {
        var formObjectElement = $(ev.currentTarget).closest('.form-object'),
          view = helper.datum(formObjectElement);
        this.set('formObject', formObjectElement);
        view && that.getDelegate().requestFormObjectActivate(view.getDelegate());
      }).plugin(EVIDrag.plugins.ghost).set('ghostPosition', function (ev) {
        var container = this.get('container'),
          elemOff = this.get('formObject').offset(),
          offset = container.offset(),
          pos = {
            top: elemOff.top - offset.top,
            left: elemOff.left - offset.left
          };
        return pos;
      }).set('ghost', function (el) {
        return this.get('formObject').clone().width(this.get('formObject').outerWidth()).css('opacity', .7);
      }).plugin(EVIDrag.plugins.scroller).set('scrollContainer', function () {
        return that.$(".form-section-container");
      });
      existing.delegateDrop('.form-object-spacer').enter(function (el) {
        var draggedEntityView = helper.datum(this.getCurrentlyDragged().closest('.form-object')),
          delegateView = helper.datum(el.closest('.form-object,.form-section')),
          draggedEntity = draggedEntityView ? draggedEntityView.getDelegate() : null,
          delegate = delegateView ? delegateView.getDelegate() : null;
        if (delegate && draggedEntity && delegate.canAddChildFormObject(draggedEntity)) {
          el.addClass('drop-hover');
        }
      }).exit(function (el) {
        el.removeClass('drop-hover');
      }).drop(function (el) {
        var draggedEntityView = helper.datum(this.getCurrentlyDragged().closest('.form-object')),
          delegateView = helper.datum(el.closest('.form-object,.form-section')),
          draggedEntity = draggedEntityView ? draggedEntityView.getDelegate() : null,
          delegate = delegateView ? delegateView.getDelegate() : null,
          rowIndex = null;
        if (delegate && draggedEntity && delegate.canAddChildFormObject(draggedEntity)) {
          if (el.hasClass("last") || el.hasClass("last-internal")) {
            delegate.requestInsertAtEnd(draggedEntity);
          } else {
            rowIndex = helper.datum(el.next('.form-object')).getDelegate().getRowIndex();
            delegate.requestInsertAtIndex(draggedEntity, rowIndex);
          }
        }
      });
      var linkedSign = this.dragLinks = EVIDrag.delegate(this.$el, '.toolbar-linked .plus-sign-icon', {
        drag_min_distance: 5
      }).init(function (ev) {
        that.setupLinkedSelection(ev, this);
      }).end(function () {
        if (that._tempEl) {
          that._tempEl.remove();
          that._tempEl = null;
        }
        that._updateLineFn = function () {};
      }).move(function (ev) {
        that.refreshLinkSVGLine(ev, this);
      }).plugin(EVIDrag.plugins.scroller).set('scrollContainer', function () {
        return $(".form-section-container");
      }).set('containerOffset', function () {
        return this.get('container').offset();
      });
      linkedSign.delegateDrop('.form-object,.form-sidebar-section,.form-sidebar-attachment').drop(function (el) {
        var view = helper.datum(el),
          dependent = view ? view.getDelegate() : null,
          type = this.drag.currentlyDragged.data('type'),
          dependency = that.getDelegate().getActiveFormObject();
        if (type && view && dependency.canLinkToFormObjectByType(type, dependent)) {
          dependency.addNewDependent(type, dependent);
          that.getDelegate().refreshPropertiesTab();
        }
      }).enter(function (el) {
        var view = helper.datum(el),
          dependency = that.getDelegate().getActiveFormObject(),
          type = this.drag.currentlyDragged.data('type');
        if (view && type && dependency.canLinkToFormObjectByType(type, view.getDelegate())) {
          el.addClass('drop-link-hover');
        }
      }).exit(function (el) {
        el.removeClass('drop-link-hover');
      });
      var sections = this.dragSections = EVIDrag.delegate(this.$el, '.form-sidebar-section .dragger', {
        drag_min_distance: 5
      }).init(function (ev) {
        var sectionElement = $(ev.currentTarget).closest('.form-sidebar-section');
        this.set('section', sectionElement);
      }).set('placeholder', function (el) {
        return $('<div/>').height(el.outerHeight()).addClass(el.attr('class'));
      }).plugin(EVIDrag.plugins.sortable).set('ghostPosition', function (ev) {
        var container = this.get('container'),
          elemOff = this.get('section').offset(),
          offset = container.offset(),
          pos = {
            top: elemOff.top - offset.top,
            left: elemOff.left - offset.left
          };
        return pos;
      }).set('sortableElements', function () {
        return that.$('.form-sidebar-section');
      }).set('sortableElement', function (el) {
        return el.parent();
      }).set('ghost', function (el) {
        return this.get('section').clone().width(this.get('section').outerWidth()).css('opacity', .7);
      }).swap(function (dragged, currentIndex, newIndex) {
        delegate.requestSectionOrderByIndex(currentIndex, newIndex);
      }).plugin(EVIDrag.plugins.scroller).set('scrollContainer', function () {
        return that.$(".form-sidebar-scroller");
      });
      var hammerjsEvent = this.el.onselectstart;
      this.el.onselectstart = function (ev) {
        if (!ev._flag && hammerjsEvent) {
          return hammerjsEvent.apply(this, arguments);
        }
      };
    },
    setupLinkedSelection: function setupLinkedSelection(ev, drag) {
      var el = this.$el,
        container = drag.get('container'),
        offset = container.offset(),
        target = $(ev.currentTarget),
        elemOff = target.offset(),
        div = $("<div/>").addClass('form-object-link-dragger-container'),
        pos = {
          top: elemOff.top - offset.top,
          left: elemOff.left - offset.left
        };
      target.clone().appendTo(div).addClass('template-property-add-link-clone').css({
        top: pos.top,
        left: pos.left,
        'font-size': target.css('font-size')
      });
      pos.top += 11;
      pos.left += 11;
      el.append(div);
      this._tempEl = div;
      var svg = d3.select(div.get(0)).append('svg:svg').attr('width', '100%').attr('height', '100%');
      var circle = svg.append('svg:circle').attr('cx', pos.left).attr('cy', pos.top).attr('fill', 'rgb(6,120,155)').attr('r', 5);
      var line = svg.append('svg:line').attr('x1', pos.left).attr('y1', pos.top).attr('x2', pos.left).attr('y2', pos.top).style('stroke', 'rgb(6,120,155)').style('stroke-width', 2);
      svg.append('svg:circle').attr('cx', pos.left - 1).attr('cy', pos.top + 1).attr('fill', 'rgb(6,120,155)').attr('r', 12);
      this._updateLineFn = function (x, y) {
        line.attr('x2', x).attr('y2', y);
        circle.attr('cx', x).attr('cy', y);
      };
    },
    refreshLinkSVGLine: function refreshLinkSVGLine(ev, drag) {
      var offset = drag.get('containerOffset'),
        cursorPos = null;
      cursorPos = {
        x: ev.gesture.center.pageX,
        y: ev.gesture.center.pageY
      };
      cursorPos.x -= offset.left;
      cursorPos.y -= offset.top;
      this._updateLineFn(cursorPos.x, cursorPos.y);
    },
    render: function render() {
      var that = this,
        body = document.body;
      this._super.apply(this, arguments);
      this.$(".form-wrapper").append(this.renderToolbarFragment());
      this.setupDrag();
      $(body).on('keydown.delegateEvents' + this.cid, function (ev) {
        if (!ev.originalEvent._input && ev.target.tagName != 'INPUT' && ev.target.tagName != 'TEXTAREA' && !ev.target.isContentEditable) {
          that.handleFormKeyup(ev);
        }
      });
    },
    activateControlsTab: function activateControlsTab() {
      var delegate = this.getDelegate(),
        data = null;
      this._propertiesTabActive = false;
      data = {
        controlTypes: _.reduce(delegate.getControlTypes(), function (memory, control) {
          if (control.name == 'question' || control.name == 'label') {
            memory.groups.push(control);
          } else {
            memory.others.push(control);
          }
          return memory;
        }, {
          groups: [],
          others: []
        })
      };
      this.$('.form-toolbar-tab').removeClass('active').filter('.controls').addClass('active');
      this.$('.form-toolbar').html(this.renderControlsFragment(data));
    },
    activatePropertiesTab: function activatePropertiesTab() {
      this.$('.form-toolbar-tab').removeClass('active').filter('.properties').addClass('active');
      this._propertiesTabActive = true;
      this.refreshPropertiesTab();
    },
    activateRichtextFields: function activateRichtextFields() {
      var propContainer = $('.form-toolbar'),
        that = this;
      this._richText = propContainer.find('textarea');
      this._richText.redactor({
        linebreaks: true,
        minHeight: 70,
        tabFocus: false,
        plugins: ['hrefLocation'],
        buttons: ['bold', 'italic', 'underline', 'deleted', '|', 'unorderedlist', 'orderedlist', '|', 'link'],
        changeCallback: function changeCallback(value) {
          var el = this.$element,
            property = el.data('property');
          if (property) {
            that.currentlyEditing = true;
            that.getDelegate().propertyDidChangeOnActiveFormObject(property, value);
          }
        }
      });
    },
    refreshPropertiesTab: function refreshPropertiesTab() {
      if (this._propertiesTabActive) {
        this.currentlyRefreshing = true;
        var delegate = this.getDelegate(),
          data = delegate.getActiveFormObjectTemplateProperties();
        this.$('.form-toolbar').html(this.renderProperties(data));
        this.activateRichtextFields();
      }
      this.currentlyRefreshing = false;
    },
    formObjectWasDeleted: function formObjectWasDeleted(view) {
      if (view === this._activeFormObject) {
        this._activeFormObject = null;
      }
    },
    activateFormObject: function activateFormObject(view, noProperties) {
      if (this._activeFormObject && this._activeFormObject.el) {
        this._activeFormObject.$el.removeClass("active");
      }
      this._activeFormObject = view;
      view.$el.addClass('active');
      if (noProperties !== true) {
        this.activatePropertiesTab();
      } else {
        this.refreshPropertiesTab();
      }
    },
    handleToolBarPropertyTab: function handleToolBarPropertyTab(ev) {
      if (!$(ev.currentTarget).hasClass('active')) {
        this.getDelegate().requestPropertiesTab();
      }
    },
    handleToolBarControlsTab: function handleToolBarControlsTab(ev) {
      if (!$(ev.currentTarget).hasClass('active')) {
        this.getDelegate().requestControlsTab();
      }
    },
    handleFormObjectMouseDown: function handleFormObjectMouseDown(ev) {
      var el = $(ev.currentTarget),
        view = null,
        active = this.getDelegate().getActiveFormObject();
      if (ev.originalEvent._formObjectClick || el.hasClass("empty")) {
        return;
      }
      ev.originalEvent._formObjectClick = true;
      view = helper.datum(ev.currentTarget);
      if (view && view.getDelegate() != active) {
        this.getDelegate().requestFormObjectActivate(view.getDelegate());
      }
    },
    getFormToolBar: function getFormToolBar() {
      return this.$('.form-toolbar');
    },
    getFormObjectProperty: function getFormObjectProperty(prop) {
      var name = prop.name,
        type = prop.richtext ? 'textarea' : 'input',
        uniqueId = type + '[data-property=' + name + ']';
      return this.getFormToolBar().find(uniqueId);
    },
    isPropertiesTabActive: function isPropertiesTabActive() {
      return !!this._propertiesTabActive;
    },
    handlePropertyValueChange: function handlePropertyValueChange(ev) {
      var el = $(ev.currentTarget),
        className = el.data('class-bool'),
        dropdown = el.data('dropdown'),
        value = null,
        noLive = el.data('no-live-update'),
        property = el.data('property');
      if (ev.keyCode && noLive) {
        return;
      }
      if (property) {
        this.currentlyEditing = true;
        value = className ? el.hasClass(className) : el.val();
        if (dropdown) {
          value = this.getDelegate().getDropdownPropertyValueByIndex(value, dropdown, property);
        }
        this.getDelegate().propertyDidChangeOnActiveFormObject(property, value);
      }
    },
    handleAddSectionBtnKeydown: function handleAddSectionBtnKeydown(ev) {
      if (ev.keyCode === 13) {
        this.handleAddSectionBtn(ev);
      }
    },
    handleAddSectionBtn: function handleAddSectionBtn(ev) {
      this.getDelegate().requestAddSection();
    },
    handleAddAttachmentBtnKeydown: function handleAddAttachmentBtnKeydown(ev) {
      if (ev.keyCode === 13) {
        this.handleAddAttachmentBtn(ev);
      }
    },
    handleAddAttachmentBtn: function handleAddAttachmentBtn(ev) {
      this.getDelegate().requestAddAttachment();
    },
    handleCustomCheckboxClick: function handleCustomCheckboxClick(ev) {
      $(ev.currentTarget).toggleClass('checked').trigger('change');
    },
    handleAttachmentClick: function handleAttachmentClick(ev) {
      var el = $(ev.currentTarget),
        view = helper.datum(ev.currentTarget),
        delegate = this.getDelegate();
      if (view) {
        delegate.requestFormObjectActivate(view.getDelegate());
        delegate.requestPropertiesTab();
      }
    },
    handleAreaClick: function handleAreaClick(ev) {
      if ($(ev.target).hasClass('form-section-container')) {
        var delegate = this.getDelegate();
        delegate.requestFormObjectActivate(delegate.getActiveSection());
      }
    },
    handleRemoveLinkBtn: function handleRemoveLinkBtn(ev) {
      var el = $(ev.currentTarget).closest('.linked-item'),
        delegate = this.getDelegate(),
        active = delegate.getActiveFormObject(),
        type = el.data('type'),
        linkedID = el.data('id'),
        formObject = delegate.getFormObjectByID(linkedID);
      if (type && formObject) {
        active.removeDependent(type, formObject);
        this.refreshPropertiesTab();
      }
    },
    handleRevealLinkBtn: function handleRevealLinkBtn(ev) {
      var el = $(ev.currentTarget).closest('.linked-item'),
        delegate = this.getDelegate(),
        linkedID = el.data('id'),
        formObject = delegate.getFormObjectByID(linkedID);
      if (formObject) {
        delegate.revealFormObject(formObject).then(function () {
          delegate.highlightFormObject(formObject);
        });
      }
    },
    handleGoToControlBtnKeydown: function handleGoToControlBtnKeydown(ev) {
      if (ev.keyCode === 13) {
        this.handleGoToControlBtn(ev);
      }
    },
    handleGoToControlBtn: function handleGoToControlBtn(ev) {
      var delegate = this.getDelegate(),
        active = delegate.getActiveFormObject();
      if (active) {
        delegate.revealFormObject(active);
      }
    },
    handlePropertyButtonKeydown: function handlePropertyButtonKeydown(ev) {
      if (ev.keyCode === 13) {
        this.handlePropertyButtonClick(ev);
      }
    },
    handlePropertyButtonClick: function handlePropertyButtonClick(ev) {
      var handler = $(ev.currentTarget).data('handler'),
        delegate = this.getDelegate(),
        active = delegate.getActiveFormObject();
      if (handler && active && active[handler]) {
        active[handler]();
      }
    },
    handleInputKeyup: function handleInputKeyup(ev) {
      ev.originalEvent._input = true;
    },
    handleFormKeyup: function handleFormKeyup(ev) {
      var keyCode = ev.keyCode,
        character = String.fromCharCode(keyCode).toLowerCase(),
        ctrlKey = ev.ctrlKey,
        delegate = this.getDelegate();
      switch (keyCode) {
        case 38:
          ev.preventDefault();
          delegate.activatePreviousFormObject();
          return false;
        case 40:
          ev.preventDefault();
          delegate.activateNextFormObject();
          return false;
        case 37:
          ev.preventDefault();
          delegate.activateParentFormObject();
          return false;
        case 39:
          ev.preventDefault();
          delegate.activateFirstChildFormObject();
          return false;
      }
      ;
      switch (character) {
        case 'l':
          ev.preventDefault();
          delegate.activateLabelOnActiveFormObject();
          return false;
        case 't':
          ev.preventDefault();
          delegate.activateTextOnActiveFormObject();
          return false;
      }
      ;
    },
    handlePropertyListRemoveClick: function handlePropertyListRemoveClick(ev) {
      var el = $(ev.currentTarget);
      row = el.closest(".property-item"), property = el.closest('.property-list').data('property');
      index = row.data("list-item-id");
      this.getDelegate().requestPropertyListItemRemove(property, index);
    },
    destroy: function destroy() {
      $(document.body).off('.delegateEvents' + this.cid);
      this.dragControls.destroy();
      this.dragExisting.destroy();
      this.dragLinks.destroy();
      return this._super.apply(this, arguments);
    },
    handleSectionDeleteBtn: function handleSectionDeleteBtn(ev) {
      var el = $(ev.currentTarget);
      view = helper.datum(el.closest(".form-sidebar-section"));
      if (view) {
        this.getDelegate().requestDeleteSection(view.getDelegate());
      }
      ev.stopPropagation();
    },
    handleAttachmentDeleteBtn: function handleAttachmentDeleteBtn(ev) {
      var el = $(ev.currentTarget);
      view = helper.datum(el.closest(".form-sidebar-attachment"));
      if (view) {
        this.getDelegate().requestDeleteAttachment(view.getDelegate());
      }
      ev.stopPropagation();
    }
  });
  return FormDesignerView;
});

